function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3 5)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 -5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.957,39.809l-5.33-1.523V36.561a5.281,5.281,0,0,1-5.893,0v1.725L5.4,39.809A3.328,3.328,0,0,0,3,43V45.93a.368.368,0,0,0,.368.368H23.993a.368.368,0,0,0,.368-.368V43A3.328,3.328,0,0,0,21.957,39.809Z",
  transform: "translate(-3 -23.464)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.524,1A5.531,5.531,0,0,0,17,6.524V8c0,2.956,2.363,6.261,5.524,6.261S28.049,10.953,28.049,8V6.524A5.531,5.531,0,0,0,22.524,1Z",
  transform: "translate(-11.844 -1)",
  fill: "#fff"
})));

var SvgAlert1 = function SvgAlert1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21.361 22.834",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert-1.ef16df5e.svg";
export { ForwardRef as ReactComponent };